// extracted by mini-css-extract-plugin
export default {"button":"Qn-z","reviewSort":"Rn-z"};